import React, { useEffect } from "react";
import "./index.css";
const Vendor101 = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    console.log("window.location.search", window.location.search)
    const name = params.get("name") || "";
    const address = params.get("address") || "";
    const email = params.get("email") || "";
    const phoneRaw = params.get("phone") || "";
    const utm_content = params.get("utm_content") || "";

    const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    const getNameParts = (fullName) => {
      const parts = fullName.trim().split(/\s+/);
      return {
        fname: parts[0] || "",
        lname: parts[parts.length - 1] || "",
      };
    };

    const formatPhone = (phone) => {
      const digits = phone.replace(/\D/g, "");
      return digits.slice(-10);
    };

    const parseAddress = (addr) => {
      const regex = /(.*),\s*([^,]+),\s*([A-Z]{2})\s*(\d{5})/i;
      const match = addr.match(regex);
      if (match) {
        return {
          street: match[1].trim(),
          city: match[2].trim(),
          state: match[3].trim(),
          zip: match[4].trim(),
          isComplete: true,
        };
      }
      return { isComplete: false };
    };

    const fallbackBase =
      "https://pulse.zbuyer.com/?landing=selling&autostart=1&MID=10600&affid=00017203";

    const redirectUser = (baseUrl, extraParams) => {
      const url = new URL(baseUrl);
      Object.entries(extraParams).forEach(([key, value]) => {
        url.searchParams.set(key, value);
      });
      window.location.href = url.toString();
    };

    const run = async () => {
      const validEmail = isValidEmail(email);
      const { fname, lname } = getNameParts(name);
      const phone = formatPhone(phoneRaw);
      const addressParts = parseAddress(address);

      const commonParams = {
        zstreet: addressParts.street || "",
        zcity: addressParts.city || "",
        zstate: addressParts.state || "",
        zzipcode: addressParts.zip || "",
        zfname: fname,
        zlastname: lname,
        zemail: validEmail ? email : "",
        zphone: phone,
        custom1: utm_content,
      };

      const hasValidInputs =
        name.trim() && address.trim() && validEmail && phone.length === 10;

      if (hasValidInputs) {
        redirectUser(fallbackBase, commonParams);
      } else if (address.trim()) {
        try {
          const apiUrl = `https://api.palisade.ai/checkout/lookup/zipcode?address=${encodeURIComponent(
            address
          )}&vendor_id=101`;

          const res = await fetch(apiUrl);
          const data = await res.json();

          if (data?.data?.redirect_url && data?.data?.address) {
            const a = data.data.address;
            redirectUser(data.data.redirect_url, {
              ...commonParams,
              zstreet: `${a.number || ""} ${a.street || ""} ${a.type || ""} ${
                a.suffix || ""
              }`.trim(),
              zcity: a.city || "",
              zstate: a.state || "",
              zzipcode: a.zip || "",
            });
          } else {
            redirectUser(fallbackBase, commonParams);
          }
        } catch (err) {
          redirectUser(fallbackBase, commonParams);
        }
      } else {
        redirectUser(fallbackBase, commonParams);
      }
    };

    run();
  }, []);

  return (
    <div className="spinner-container">
      <div className="spinner"></div>
    </div>
  );
};

export default Vendor101;
